function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Warstwa 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": 3
}, /*#__PURE__*/React.createElement("circle", {
  cx: 23.5,
  cy: 23.5,
  r: 23.5,
  fill: "#21374d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.5 15.44v-3.9h-4.13a4.86 4.86 0 00-4.26 4.38v4.18H17.5v4.4h3.57v11h4.22V24.45H29l.47-4.33h-4.13v-3.19a1.46 1.46 0 011.39-1.51z",
  fill: "#fff"
})));

function SvgFacebookicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 47 47"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NyA0NyI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMyMTM3NGQ7fS5jbHMtMntmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5aYXPDs2IgMjwvdGl0bGU+PGcgaWQ9IldhcnN0d2FfMiIgZGF0YS1uYW1lPSJXYXJzdHdhIDIiPjxnIGlkPSJfMyIgZGF0YS1uYW1lPSIzIj48Y2lyY2xlIGNsYXNzPSJjbHMtMSIgY3g9IjIzLjUiIGN5PSIyMy41IiByPSIyMy41Ii8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMjkuNSwxNS40NFYxMS41NGwtNC4xMywwYTQuODYsNC44NiwwLDAsMC00LjI2LDQuMzh2NC4xOEgxNy41VjI0LjVoMy41N3YxMWg0LjIyVjI0LjQ1SDI5bC40Ny00LjMzSDI1LjM0VjE2LjkzYTEuNDYsMS40NiwwLDAsMSwxLjM5LTEuNTFaIi8+PC9nPjwvZz48L3N2Zz4=";
export { SvgFacebookicon as ReactComponent };